import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const DynamicRendererRoot = superstyled({
  name: 'DynamicRenderer',
  slot: 'Root',
  tag: Box,
  styles: ({ theme, ischatmode }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flex: 1, // fill the parent height
    minHeight: 0, // allow shrinking inside flex
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    position: 'relative',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    ...(!ischatmode && {
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2)
      },
      padding: theme.spacing(4, 4, 0, 4)
    })
  })
});

export const DynamicRendererInstructionGroup = superstyled({
  name: 'DynamicRenderer',
  slot: 'InstructionGroup',
  tag: Box,
  propsNeeded: ['fullWidth'],
  styles: ({ theme, fullWidth = false }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    margin: '0 auto',
    maxWidth: fullWidth ? '100%' : '35rem',
    width: fullWidth ? '100%' : 'min(100vw - 2rem, 35rem)'
  })
});

export const DynamicRendererComponentWrapper = superstyled({
  name: 'DynamicRenderer',
  slot: 'ComponentWrapper',
  tag: Box,
  styles: () => ({
    scrollMarginTop: '5rem'
  })
});

export const DynamicRendererBottomSentinel = superstyled({
  name: 'DynamicRenderer',
  slot: 'BottomSentinel',
  tag: Box,
  styles: ({ theme }) => ({
    height: '10px',
    width: '100%',
    marginBottom: theme.spacing(2)
  })
});
